class URLUtils {
	static path(path: string[]): string {
		// Filter out undefined or empty strings from the path array
		path = path.filter((p) => p);
		path.unshift(process.env.NEXT_PUBLIC_SITE_URL as string);
		// replace all double '//' with single `/`, except for the `://`
		return path.join('/').replace(/(?<!:)\/*\//g, '/');
	}
}

export default URLUtils;
